import { styled } from '@mui/material/styles';

import DirectRequestFormBase from '@/components/DirectRequestForm/DirectRequestForm';

export const Heading = styled('div')(({ theme }) => ({
  '& > *': {
    ...theme.typography.h1,
    margin: 0,
    fontWeight: theme.typography.fontWeightRegular,
    strong: {
      fontWeight: theme.typography.fontWeightBlack,
    },
  },
  textAlign: 'center',
  marginBottom: theme.spacing(5),
  maxWidth: 724,

  [theme.breakpoints.down('md')]: {
    '& > *': {
      ...theme.typography.h2,
      fontWeight: theme.typography.fontWeightRegular,
    },
    marginBottom: theme.spacing(3),
  },
}));

export const ImageWrapper = styled('div')(({ theme }) => ({
  position: 'relative',
  width: '100%',
  height: 388,
  marginRight: theme.spacing(3),

  '& > div': {
    height: '100%',
    maxWidth: '500px !important',
    maxHeight: '348px !important',
    top: '50% !important',
    transform: 'translateY(-50%)',
  },
}));

export const FormWrapper = styled('div')(({ theme }) => ({
  minWidth: 540,
  marginLeft: theme.spacing(1),
  display: 'flex',
  justifyContent: 'center',

  [theme.breakpoints.down('md')]: {
    minWidth: 'initial',
    maxWidth: 540,
    width: '100%',
  },
}));

export const DirectRequestForm = styled(DirectRequestFormBase)(() => ({
  maxWidth: 'initial',
  margin: 0,
}));
